export const SUBSCRIPTION_CONFIRMATION = "subscription-confirmation";

export const SUBSCRIPTION_CONFIRMATION_CHECKBOX = "subscription-confirmation-checkbox";
